/* eslint-disable max-len */
import { useQuery } from '@apollo/client';
import { useMemo, useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';

import DashboardWrap from '../../components/DashboardWrap';
import PropertyComp from '../../components/PropertyComp';
import RolesAndPermissionGuard from '../../components/RolesAndPermissionGuard';
import AdminActionedRecordDetails from '../../components/AdminActionedRecordDetails';

import { GET_ADMIN_GUARANTEE_BY_ID } from '../../graphql/admin_queries';
import { cleanUpAdminSingleGuaranteeRecord } from '../../utils/helpers';
import { AdminRouteName } from '../CONSTANTS';

import GuaranteeSummary from './GuaranteeSummary';
import PermissionDenied from '../PermissionDenied';

import GoBackIcon from '../../svgs/GoBackIcon';

import './AdminGuaranteeDetails.scss';
import EmptyPageLoader from '../../components/EmptyPageLoader';

const AdminGuaranteeDetails = () => {
  const history = useHistory();
  const { guaranteeId } = useParams<{ guaranteeId: string }>();
  const { data, refetch, loading } = useQuery<
    {
      getRentGuarantee: any;
    },
    { id: string }
  >(GET_ADMIN_GUARANTEE_BY_ID, { variables: { id: guaranteeId } });

  const guarantee = useMemo(() => data?.getRentGuarantee, [data]);
  const payload:any = cleanUpAdminSingleGuaranteeRecord(guarantee);
  const property = payload?.property || [];
  // const shouldShowCancel = ['PENDING']?.includes(payload?.status);
  const isCancelled = ['CANCELLED', 'REFUNDED']?.includes(payload?.status);
  const [showAdminActionInfo, setShowAdminActionInfo] = useState(true);

  const AdminActionTitle = () => {
    let title = 'Guarantee Request Approval!';
    if (isCancelled) {
      title = 'Guarantee Request Denial!';
    } else if (guarantee?.meta?.manualPaymentApprovedBy && payload?.status === 'PAID') {
      title = 'Pre Approval Guarantee Request Marked As Paid!';
    } else {
      title = 'Guarantee Request Approval!';
    }
    return title;
  };

  const AdminAction = () => {
    let title = 'approved';
    if (isCancelled) {
      title = 'denied';
    } else if (guarantee?.meta?.manualPaymentApprovedBy && payload?.status === 'PAID') {
      title = 'marked as paid';
    } else {
      title = 'approved';
    }
    return title;
  };

  const actionAdminLastName = guarantee?.approvedByAdmin?.lastName || guarantee?.meta?.manualPaymentApprovedBy?.lastName;
  const actionAdminFirstName = guarantee?.approvedByAdmin?.firstName || guarantee?.meta?.manualPaymentApprovedBy?.firstName;

  return (
    <DashboardWrap>
      <RolesAndPermissionGuard permissionName="can-get-loan" hasErrorTemplate={<PermissionDenied height="100vh" />}>
        <div className="guarantee-details-dashboard-loader" style={{ display: loading ? 'block' : 'none' }}>
          <EmptyPageLoader />
        </div>

        <div className="guarantee-details-cover" style={{ display: loading ? 'none' : 'block' }}>
          <div className="title">
            <GoBackIcon onClick={() => history?.goBack()} />
            Guarantees
          </div>
          <div className="guarantee-ref-id-and-badge">
            <span className="guarantee-ref-span">Guarantee Ref:</span>
            <span className="ref-no-span">{payload?.refNo}</span>
            <div className="guarantee-badge-span">Canada Rent</div>
          </div>

          <GuaranteeSummary payload={payload} refetch={refetch} />

          <div style={{
            display: 'flex', gap: '40px', flexWrap: 'wrap', justifyContent: property && payload?.guaranteeType === 'default' ? 'space-between' : 'flex-end', marginTop: '32px',
          }}
          >
            {
              (property && payload?.guaranteeType === 'default') && (
              <div style={{
                backgroundColor: '#fff',
              }}
              >
                <PropertyComp property={property} width="420px" />
              </div>
              )
            }

            {(guarantee?.approvedByAdmin || guarantee?.meta?.manualPaymentApprovedBy)
            && showAdminActionInfo && (
              <div className="">
                <AdminActionedRecordDetails
                  recordName={AdminActionTitle()}
                  recordTitle="request"
                  action={AdminAction()}
                  lastName={actionAdminLastName}
                  firstName={actionAdminFirstName}
                  routePath={payload?.guaranteeType === 'pre-approval' ? AdminRouteName.allPreApprovalGuaranteesRoute : AdminRouteName.allMainGuaranteesRoute}
                  tableTitle="Guarantee"
                  onClose={() => setShowAdminActionInfo(false)}
                />
              </div>
            )}
          </div>

        </div>
      </RolesAndPermissionGuard>

    </DashboardWrap>
  );
};

export default AdminGuaranteeDetails;
